﻿//Jquery
import "./jquery-global.js";
import $ from "jquery";
import {loaderShow} from "./loader";

export function initiatePayment() {
    let paymentIframe = document.getElementById('targetPaymentIframe');
    let accountPaymentIframe = document.getElementById('accountPaymentIframe');

    if (paymentIframe) {
        loadScript('/Apps/ElliottBrothers/Content/lib/rxp-js/dist/rxp-js.min.js', function () {

            $(window).on("beforeunload", function () {
                loaderShow('body');
            });

            let serviceUrl = paymentIframe.dataset.serviceUrl;
            let serviceJson = paymentIframe.dataset.serviceJson;
            let url = paymentIframe.dataset.compeltePaymentUrl;

            RealexHpp.setHppUrl(serviceUrl);
            let json = JSON.parse(serviceJson);
            RealexHpp.embedded.init(
                "autoload",
                "targetPaymentIframe",
                url,
                json,
                {
                    onResize: function (data) {
                        $(paymentIframe).css(data);
                    }
                }
            );
            document.querySelector("body").classList.add("loaded");
        });
    }
// note this payment form works differently to main payment form due to requiring callback to fields for payment info. Consider changing to above re duplicate payments. Ask W.A
    if (accountPaymentIframe) {
        loadScript('/Apps/ElliottBrothers/Content/lib/rxp-js/dist/rxp-js.min.js', function () {
            $(window).on("beforeunload", function () {
                loaderShow('body');
            });

            let serviceUrl = accountPaymentIframe.dataset.serviceUrl;
            let serviceJson = accountPaymentIframe.dataset.serviceJson;
            RealexHpp.setHppUrl(serviceUrl);
            let json = JSON.parse(serviceJson);
            RealexHpp.embedded.init(
                "autoload",
                "accountPaymentIframe",
                function (data) {
                    loaderShow('body');
                    let form = document.getElementById('paymentResultForm');
                    form.querySelector('input[name="responseJson"]').value = JSON.stringify(data);
                    form.submit();
                },
                json,
                {
                    onResize: function (data) {
                        $(accountPaymentIframe).css(data);
                    }
                }
            );
            document.querySelector("body").classList.add("loaded");
        });
    }
}


function loadScript(url, callback) {
    let body = document.body;
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onreadystatechange = callback;
    script.onload = callback;
    body.appendChild(script);
}